import { memo } from 'react'
import { cn } from '@/lib/utils'
import { formatCurrencyAutoLocale } from '@/utils/tools'

const BudgetChangeTooltip = memo(
    ({ type, action, budgetDetails, userTime, adAccountTime, originIcon: OriginIcon, actionIcon: ActionIcon }) => {
        const isIncrease = type === 'adset_budget_increased'
        const delta = budgetDetails
            ? parseFloat((parseFloat(budgetDetails.newAmount) - parseFloat(budgetDetails.oldAmount)).toFixed(2))
            : null
        const formattedOldAmount = budgetDetails
            ? formatCurrencyAutoLocale({
                  amount: parseFloat(budgetDetails.oldAmount),
                  currency: budgetDetails.currency,
                  showCode: false,
              })
            : null
        const formattedNewAmount = budgetDetails
            ? formatCurrencyAutoLocale({
                  amount: parseFloat(budgetDetails.newAmount),
                  currency: budgetDetails.currency,
                  showCode: false,
              })
            : null
        const formattedDelta =
            delta !== null && !Number.isNaN(delta)
                ? `${delta > 0 ? '+' : '-'}${formatCurrencyAutoLocale({
                      amount: Math.abs(delta),
                      currency: budgetDetails.currency,
                      showCode: false,
                  })}`
                : null
        const originLabel =
            action.origin === 'meta'
                ? 'Meta Platform'
                : action.origin === 'system'
                  ? 'Turba App'
                  : action.actor_name || 'Manual Action'

        return (
            <div className={cn('tw:flex tw:flex-col tw:gap-6 tw:w-[400px] tw:box-border tw:pr-8', 'tw:bg-[#071727]')}>
                <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
                    <div className="tw:flex tw:items-center tw:gap-3">
                        <div className="tw:relative tw:cursor-help tw:inline-block">
                            <ActionIcon size={27} />
                            {/* Origin indicator positioned at bottom-right corner */}
                            <div className="tw:absolute tw:bottom-0 tw:right-0 tw:translate-x-1/4 tw:translate-y-1/4">
                                <OriginIcon size={10} />
                            </div>
                        </div>
                        <div className="tw:flex tw:flex-col tw:gap-1">
                            <div className="tw:flex tw:items-center tw:gap-2">
                                <span className="tw:text-sm tw:font-medium tw:text-white">
                                    Ad set budget{' '}
                                    <span className={cn(isIncrease ? 'tw:text-[#4DD15E]' : 'tw:text-[#E0295E]')}>
                                        {isIncrease ? 'increased' : 'decreased'}
                                    </span>{' '}
                                    by {originLabel}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {formattedOldAmount && formattedNewAmount && (
                    <div className="tw:flex tw:justify-between">
                        <div className="tw:flex tw:items-center tw:gap-2">
                            <div className="tw:text-xl">{formattedOldAmount}</div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14 8L18 12M18 12L14 16M18 12H6"
                                    stroke="#899CBD"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="tw:text-xl">{formattedNewAmount}</div>
                        </div>
                        {formattedDelta && (
                            <span className={cn('tw:text-xl', isIncrease ? 'tw:text-[#4DD15E]' : 'tw:text-[#E0295E]')}>
                                {formattedDelta}
                            </span>
                        )}
                    </div>
                )}

                <div className="tw:flex tw:gap-6">
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">User Time</span>
                        <span className="tw:text-sm">{userTime}</span>
                    </div>
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">Ad Account Time</span>
                        <span className="tw:text-sm">{adAccountTime}</span>
                    </div>
                </div>
            </div>
        )
    },
)

BudgetChangeTooltip.displayName = 'BudgetChangeTooltip'

export default BudgetChangeTooltip
